import React from 'react';
import { Pagination as AntPagination } from 'antd';

/**
 * Wrapper component for Ant Design Pagination
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design Pagination functionality including page size, showSizeChanger, and showTotal options.
 * 
 * @component
 * @example
 * import { Pagination } from '../GeneralComponents/ui';
 * 
 * <Pagination defaultCurrent={1} total={50} />
 * <Pagination defaultCurrent={1} total={50} showSizeChanger showQuickJumper />
 * <Pagination
 *   total={85}
 *   showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
 *   defaultPageSize={20}
 * />
 * 
 * @see https://ant.design/components/pagination/ - Ant Design Pagination documentation
 */
const Pagination = (props) => {
  return <AntPagination
    {...props}
    showSizeChanger={props.showSizeChanger || false}
    showQuickJumper={props.showQuickJumper || false}
    showTotal={props.showTotal || false}
  />;
};

export default Pagination;

